import { z } from 'zod';
import { getPaginationSchema } from 'src/components/form/zod-schemas';
import { usePageParamsFromSchema } from 'src/hooks/use-page-params-from-schema';

const schema = z
  .object({
    userName: z.string().nullable().default(null),
    userEmail: z.string().nullable().default(null),
    organisationSearchQuery: z.string().nullable().default(null),
    isOrganisationAssignmentActive: z
      .enum(['true', 'false'])
      .nullable()
      .default(null),
    isUserActive: z.enum(['true', 'false']).nullable().default(null),
  })
  .merge(getPaginationSchema());

export const useHydrogenUserInteractionOverviewPageParams = () => {
  return usePageParamsFromSchema(schema, {
    filters: {
      userName: { label: 'User Name' },
      userEmail: { label: 'User Email' },
      organisationSearchQuery: { label: 'User Organisation' },
      isOrganisationAssignmentActive: {
        label: 'Active Organisation Assignment',
      },
      isUserActive: { label: 'User Active' },
    },
  });
};

export type HydrogenUserInteractionOverviewPageParams = ReturnType<
  typeof useHydrogenUserInteractionOverviewPageParams
>;
